import React from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Slider from "react-slick";

// Importation des styles de slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Importation des images du slider
import img1 from "../components/assets/slider1.jpg";
import img2 from "../components/assets/slider2.jpg";
import img3 from "../components/assets/slider3.jpg"; 
import img4 from "../components/assets/slider4.jpg";

function Home() {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <main>
      {/* Section Hero */}
      <section className="hero">
        <div className="hero-content">
          <h1>
            POUR LES PROFESSIONNELS <span>EXIGEANTS</span>
          </h1>
          <p>
            Qualité, fiabilité et tout le nécessaire sous un même toit à prix
            juste.
          </p>
          <p>Des solutions solides pour vos besoins quotidiens.</p>
          <Link to="/products" className="btn">
            NOS PRODUITS
          </Link>
        </div>

        <div className="hero-image">
          <Slider {...sliderSettings}>
            <div>
              <img src={img1} alt="Slide 1" />
            </div>
            <div>
              <img src={img2} alt="Slide 2" />
            </div>
            <div>
              <img src={img3} alt="Slide 3" />
            </div>
            <div>
              <img src={img4} alt="Slide 4" />
            </div>
          </Slider>
        </div>
      </section>

      {/* Section Pourquoi nous choisir */}
      <section className="why-choose">
        <h2>POURQUOI NOUS CHOISIR ?</h2>
        <p className="subtitle">
          <span>Un large choix de produits</span> •
          <span> Qualité et fiabilité</span> •<span> Conseils d'experts</span> •
          <span> Engagement durable</span>
        </p>
        <div className="why-content">
          <div className="why-box">
            <h3>Un large choix de produits</h3>
            <p>
              Nous avons tout ce qu'il vous faut pour vos travaux de rénovation
              et/ou de construction.
            </p>
          </div>
          <div className="why-box">
            <h3>Qualité et fiabilité</h3>
            <p>
              La qualité est au cœur de notre mission. Chaque produit que nous
              proposons est soigneusement sélectionné pour sa robustesse et sa
              performance et a été testé pour sa durabilité et sa fiabilité.
            </p>
          </div>
          <div className="why-box">
            <h3>Conseils d'experts</h3>
            <p>
              Notre équipe, composée de passionnés et de professionnels, est là
              pour vous guider dans vos choix et vous offrir des solutions
              adaptées à vos besoins.
            </p>
          </div>
          <div className="why-box">
            <h3>Engagement durable</h3>
            <p>
              Chaque projet mérite d'être bâti sur des bases solides, et cela
              commence par des matériaux de qualité et un service irréprochable.
            </p>
          </div>
        </div>

        <div className="why-footer">
          <p>
            <strong>ETOILE BRICOLAGE</strong> est votre partenaire de confiance
            pour tout ce qui concerne la quincaillerie. <br />
            Explorez notre site pour découvrir tout ce que nous avons à offrir !
          </p>
        </div>
      </section>
    </main>
  );
}

export default Home;
